import useDialog from "@hooks/useDialog";
import React from "react";

export default function ImagePreview({
  children,
  imageUrl,
}: {
  children: React.ReactNode;
  imageUrl: string;
}) {
  const { openImagePreview } = useDialog();

  return (
    <div
      className="cursor-zoom-in"
      onClick={() => {
        openImagePreview(imageUrl);
      }}
    >
      {children}
    </div>
  );
}
